import React from 'react'

const DigitalInnovationLab = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <p>Our Services</p>
            <h2>Digital Innovation Lab</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-md-6">
        <div>
          <h4><b>INNOVATION BEGINS HERE…</b> Lets build something amazing together and transform your Today with Tomorrows technology</h4>
          <br />
          <p>In the world of business, the words “disrupt, innovate, and transform” have become the new normal. For companies looking to make their mark, digital transformation is now the pathway to create revenue and new value, increase profitability, and improve 
            employee and customer retention. It can also help remove IT complexities, risks, and barriers to innovation, allowing organizations to meet evolving business demands. 
            To remain competitive, organization needs to embrace best practices that will help leverage and increase the effectiveness of these channels. 
          </p>
          <p>Techarabiya’ s Digital Innovation Lab is a new digital and technology incubator designed to encourage dynamic interaction, real time experimentation and rapid 
            prototyping by engaging Individuals and Enterprises in creative and meaningful ways where our experts helps you to tackle your business problems and assist you to 
            uncover new opportunities. With access to our Lab, Product Ideation, Proto Typing and Development becomes handy and at your fingertips. Reach new and game-changing levels of performance by modernizing your digital capabilities. We help you in setting up:
          </p>
          <ul className="list-check list-unstyled">
            <li><i className="far fa-check-circle" />Digital Strategy</li>
            <li> <i className="far fa-check-circle" />Customer Transformation Journey</li>
            <li><i className="far fa-check-circle" />Intelligent Process Automation</li>
            <li><i className="far fa-check-circle" />Omni Channel Solutions</li>
            <li><i className="far fa-check-circle" />Product Ideation and Prototyping</li>
            <li><i className="far fa-check-circle" />Financial Impact Modeling/ROI</li>
            <li><i className="far fa-check-circle" />Digital Enterprise</li>
          </ul>
        </div>
      </div>
      <div className="col-sm-12 col-md-6">
        <img src="./img/digi-1.png" className="img-fluid service-image" />
      </div>
    </div>
  </div>
</div>

        </div>
    )
}

export default DigitalInnovationLab
